import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWhiteAsteriskLock = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 14,
	viewBox: "0 0 12 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M1.82002 3.79387C1.82002 2.78767 2.20352 1.82269 2.88616 1.1112C3.5688 0.39971 4.49466 0 5.46006 0C6.42546 0 7.35132 0.39971 8.03396 1.1112C8.7166 1.82269 9.1001 2.78767 9.1001 3.79387V4.42618H10.0101C10.2515 4.42618 10.4829 4.52611 10.6536 4.70398C10.8242 4.88185 10.9201 5.1231 10.9201 5.37464V7.58773H9.70677V5.6908H1.21335V12.0139H6.06673V13.2785H0.91001C0.66866 13.2785 0.437196 13.1786 0.266536 13.0007C0.0958758 12.8229 0 12.5816 0 12.3301V5.37464C0 5.1231 0.0958758 4.88185 0.266536 4.70398C0.437196 4.52611 0.66866 4.42618 0.91001 4.42618H1.82002V3.79387ZM7.88675 3.79387C7.88675 3.12307 7.63109 2.47975 7.17599 2.00542C6.7209 1.5311 6.10366 1.26462 5.46006 1.26462C4.81646 1.26462 4.19922 1.5311 3.74413 2.00542C3.28904 2.47975 3.03337 3.12307 3.03337 3.79387V4.42618H7.88675V3.79387ZM10.7017 12.1372L11.0081 14L9.40344 13.1205L7.79879 13.9994L8.10516 12.1372L6.80688 10.8182L8.60081 10.5463L9.40344 8.85236L10.2061 10.5469L12 10.8188L10.7017 12.1372Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgWhiteAsteriskLock);
export { ForwardRef as ReactComponent };
